class jollyQuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) => button.addEventListener("click", this.onButtonClick.bind(this)));
    this.checkInputValue(this.input.value);
  }
  checkInputValue(val) {
    const buttonMinus = this.querySelector(".quantity__button[name='minus']");
    if (val == 1) {
      buttonMinus.classList.add("disabled");
    }
  }
  onInputChange(event) {
    this.validateQtyRules();
    //if(document.querySelector('upsell-variant-picker') != null) document.querySelector('upsell-variant-picker').updateMainWidgetPrices(parseInt(event.target.value,10));
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    clickOnCheckedOption();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
    clickOnCheckedOption();
  }
}
customElements.define("jolly-quantity-selector", jollyQuantitySelector);

/**
 * Variant Picker Module
 * Version basée sur la classe VariantChange de jc-bundle-product.js
 */
class VariantPicker extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      variants: this.querySelectorAll(".js-variants-update"),
      variantsJSON: this.querySelector("[data-product-variants-json]"),
      productMetafieldsImageJSON: this.querySelector("[data-product-metafields-image-json]"),
      sectionId: "ajax-jolly-main-product-info",
      // Alternative call to the original section of product
      // sectionId: this.dataset.sectionId
    };
    this.init();
  }

  connectedCallback() {
    document.dispatchEvent(new Event("variantChangeInitialized"));
  }

  disconnectedCallback() {
    this.cleanup();
  }

  async updateProductInfo(productHandle, currentVariantId, sectionId, preorder) {
    try {
      const response = await fetch(`${window.Shopify.routes.root}products/${productHandle}?variant=${currentVariantId}&section_id=${sectionId}`);
      if (!response.ok) throw new Error(`Failed to fetch product: ${response.statusText}`);
      const data = await response.text();
      const parser = new DOMParser();
      const parsedData = parser.parseFromString(data, "text/html");
      this.updateElements(parsedData);
      this.updateStickyVariantLabels();
      this.clickOnCheckedOption();
      if (preorder !== null) this.updateATCPreorder(preorder);
    } catch (error) {
      console.error(`An error occurred: ${error}`);
    }
    document.body.dispatchEvent(new Event("variantUpdateElements"));
  }

  // Update various elements with new content
  updateElements(parsedData) {
    var _a, _b, _c, _d;
    const oldVariantsBlock = document.querySelector(".jolly--variant_selectors");
    let newVariantsHtml = (_a = parsedData.querySelector(".jolly--variant_selectors")) == null ? void 0 : _a.innerHTML;
    const oldBuyButtonBlock = document.querySelector("#buy-button-block");
    let newBuyButtonHtml = (_b = parsedData.querySelector("#buy-button-block")) == null ? void 0 : _b.innerHTML;
    const oldStickyBuyButtonBlock = document.querySelector("#js-main-product-sticky-atc");
    let newStickyBuyButtonHtml = (_c = parsedData.querySelector("#js-main-product-sticky-atc")) == null ? void 0 : _c.innerHTML;
    const oldStickyVariantsBlock = document.querySelector(".jolly-sticky-atc--variant_selectors");
    let newStickyVariantsHtml = (_d = parsedData.querySelector(".jolly-sticky-atc--variant_selectors")) == null ? void 0 : _d.innerHTML;

    // Remplacer variant-picker par variant-picker-reusable dans le HTML mis à jour
    if (newVariantsHtml) {
      newVariantsHtml = newVariantsHtml.replace(/variant-picker/g, "variant-picker-reusable");
    }
    if (newBuyButtonHtml) {
      newBuyButtonHtml = newBuyButtonHtml.replace(/variant-picker/g, "variant-picker-reusable");
    }
    if (newStickyBuyButtonHtml) {
      newStickyBuyButtonHtml = newStickyBuyButtonHtml.replace(/variant-picker/g, "variant-picker-reusable");
    }
    if (newStickyVariantsHtml) {
      newStickyVariantsHtml = newStickyVariantsHtml.replace(/variant-picker/g, "variant-picker-reusable");
    }

    oldVariantsBlock ? (oldVariantsBlock.innerHTML = newVariantsHtml) : null;
    oldBuyButtonBlock ? (oldBuyButtonBlock.innerHTML = newBuyButtonHtml) : null;
    oldStickyBuyButtonBlock ? (oldStickyBuyButtonBlock.innerHTML = newStickyBuyButtonHtml) : null;
    oldStickyVariantsBlock ? (oldStickyVariantsBlock.innerHTML = newStickyVariantsHtml) : null;

    // Réattacher les événements après la mise à jour du HTML
    this.reattachEventListeners();

    const enableSubscriptionSystem = document.querySelector(".rc-container-wrapper");
    if (enableSubscriptionSystem) {
      this.handlePricesAndDiscounts();
      this.clickOnCheckedOption();
    }
  }

  // Update sticky variant labels based on checked inputs
  updateStickyVariantLabels() {
    const checkedInputs = this.querySelectorAll(".js-variants-update:checked");
    const checkedOptionIds = Array.from(checkedInputs, (input) => input.id);
    const stickyVariantLabels = document.querySelectorAll(".jc-sticky-variant-label");
    stickyVariantLabels.forEach((label) => {
      if (checkedOptionIds.includes(label.htmlFor)) {
        label.setAttribute("data-checked", "");
      } else {
        label.removeAttribute("data-checked");
      }
    });
  }

  updateDateDelivery(data) {
    const element = document.querySelector(".jc-delivery-fill-please");
    if (!element) return;
    const content = element.querySelector(".jc-delivery-date--text");
    const boutonModal = document.querySelector('button[data-modal="#modal_preorder"]');

    if (data) {
      if (content) {
        const clonedBoutonModal = boutonModal.cloneNode(true);
        const modal = document.querySelector("#modal_preorder");
        modal.querySelector(".jc-richtext").innerHTML = data.popup_content.replace(/\n/g, "<br>");
        element.classList.add("preorder");
        content.textContent = data.precision;
        clonedBoutonModal.classList.remove("hidden");
        if (element.querySelector("button")) {
          element.removeChild(element.querySelector("button"));
        }
        element.appendChild(clonedBoutonModal);
      } else {
        setTimeout(() => {
          this.updateDateDelivery(data);
        }, 100);
      }
    } else {
      element.classList.remove("preorder");
      element.innerHTML = document.querySelector(".delivery-date-snippet").innerHTML;
      element.classList.remove("hidden");
    }
  }

  updateATCPreorder(preorder) {
    var buttons = document.querySelectorAll("button[js-add-to-cart-btn]");
    if (preorder) {
      buttons.forEach((button) => {
        button.querySelector("#mainText").classList.add("hidden");
        button.querySelector("#altText").classList.remove("hidden");
      });
    } else {
      buttons.forEach((button) => {
        button.querySelector("#mainText").classList.remove("hidden");
        button.querySelector("#altText").classList.add("hidden");
      });
    }
  }

  init() {
    // Stocker la fonction liée pour pouvoir la supprimer plus tard
    this.boundHandleVariantChange = this.handleVariantChange.bind(this);

    this.elements.variants.forEach((element) => {
      element.addEventListener("click", this.boundHandleVariantChange);
    });

    this.handleVariantDataChanged = this.handleVariantDataChanged.bind(this);
    document.addEventListener("variantDataChanged", this.handleVariantDataChanged);
  }

  /**
   * Gère le changement de variante
   */
  async handleVariantChange() {
    var _a;
    const parsedVariantsJSON = JSON.parse(this.elements.variantsJSON.textContent);
    const checkedInputs = this.querySelectorAll(".js-variants-update:checked");
    const checkedOption = Array.from(checkedInputs, (input) => input.value);
    const currentVariant = parsedVariantsJSON.find((variant) => variant.options.join(",") === checkedOption.join(","));

    // Récupérer l'ID d'image de la variante
    const currentVariantImageId = this.getVariantImageId(currentVariant);

    if (checkedOption) {
      this.updateCarousel(checkedOption, currentVariantImageId);
    } else {
      if (currentVariantImageId) {
        const currentSlideIndex = document.querySelector(`[data-product-image-id^="${currentVariantImageId}"]`).dataset.slideIndex;
        if (window.productMainSlider) {
          window.productMainSlider.slideToLoop(currentSlideIndex, 500);
        }
        this.updateStickyImage(currentVariantImageId);
      }
    }

    const productHandle = this.dataset.productHandle;
    const currentVariantId = currentVariant.id;
    const sectionId = this.elements.sectionId;

    var preorder = null;
    const upsellVariantContainerElement = document.querySelector("#injectUpsellVariantPickerHere");
    preorder = upsellVariantContainerElement ? null : currentVariant.metafields && currentVariant.metafields.active ? true : false;

    document.dispatchEvent(
      new CustomEvent("variant:change", {
        detail: {
          variant: currentVariant,
          preorder: preorder,
        },
      })
    );

    await this.updateProductInfo(productHandle, currentVariantId, sectionId, preorder);
  }

  handleVariantDataChanged() {
    const upsellVariantContainerElement = document.querySelector("#injectUpsellVariantPickerHere");
    if (upsellVariantContainerElement) {
      document.dispatchEvent(new Event("upsellVariantChange"));
    } else {
      const parsedVariantsJSON = JSON.parse(this.elements.variantsJSON.textContent);
      const checkedInputs = this.querySelectorAll(".js-variants-update:checked");
      const checkedOption = Array.from(checkedInputs, (input) => input.value);
      const currentVariant = parsedVariantsJSON.find((variant) => variant.options.join(",") === checkedOption.join(","));
      if (currentVariant) {
        this.updateDateDelivery(currentVariant.metafields && currentVariant.metafields.active ? currentVariant.metafields : null);
        this.updateATCPreorder(currentVariant.metafields && currentVariant.metafields.active ? true : false);
      }
    }
  }

  // Update legends in the parsed data
  updateLegends(checkedInputs, parsedData) {
    checkedInputs.forEach((input, index) => {
      const l = parsedData.querySelectorAll("legend").length;
      parsedData.querySelectorAll("legend")[index].querySelector(".js-current-option").textContent = input.value;
      const stickyVariantsLegend = parsedData.querySelectorAll("legend")[index + l / 2];
      if (stickyVariantsLegend) {
        parsedData.querySelectorAll("legend")[index + l / 2].querySelector(".js-current-option").textContent = input.value;
      }
    });
  }

  cleanup() {
    document.removeEventListener("variantDataChanged", this.handleVariantDataChanged);
  }

  /**
   * Récupère l'ID d'image d'une variante donnée
   */
  getVariantImageId(variant) {
    if (!variant) return null;

    // Récupérer l'ID d'image de la variante
    let currentVariantImageId = variant.featured_image?.id;

    // Si la variante n'a pas d'image spécifique, utiliser les metaobjects
    if (!currentVariantImageId && this.elements.productMetafieldsImageJSON) {
      const parsedMetafieldsImageJSON = JSON.parse(this.elements.productMetafieldsImageJSON.textContent);
      if (parsedMetafieldsImageJSON && parsedMetafieldsImageJSON[0]?.image) {
        const firstImageId = parsedMetafieldsImageJSON[0].image.split("/").pop();
        if (firstImageId) {
          currentVariantImageId = firstImageId;
        }
      }
    }

    return currentVariantImageId;
  }

  /**
   * Met à jour le carousel - version simplifiée pour les modals
   */
  updateCarousel(options, currentVariantImageId = null) {
    // Dans les modals, on ne gère pas le carousel complexe
    // On se contente de mettre à jour l'image sticky si nécessaire
    if (currentVariantImageId) {
      this.updateStickyImage(currentVariantImageId);
    }
  }

  /**
   * Met à jour l'image du sticky ATC
   */
  updateStickyImage(imageId) {
    // Masquer toutes les images du sticky
    document.querySelectorAll("[data-sticky-product-image-id]").forEach((image) => {
      image.classList.remove("jc-opacity-100");
      image.classList.add("jc-opacity-0");
    });

    if (imageId) {
      // Chercher l'image correspondante dans le sticky
      const stickyImage = document.querySelector(`[data-sticky-product-image-id="${imageId}"]`);

      if (stickyImage) {
        stickyImage.classList.add("jc-opacity-100");
      } else {
        // Si l'image n'est pas trouvée, afficher la première image
        const firstStickyImage = document.querySelector("[data-sticky-product-image-id]");
        if (firstStickyImage) {
          firstStickyImage.classList.add("jc-opacity-100");
        }
      }
    } else {
      // Afficher la première image par défaut
      const firstStickyImage = document.querySelector("[data-sticky-product-image-id]");
      if (firstStickyImage) {
        firstStickyImage.classList.add("jc-opacity-100");
      }
    }
  }

  /**
   * Fonction clickOnCheckedOption - version simplifiée pour les modals
   */
  clickOnCheckedOption() {
    const isSubscriptionProduct = document.querySelector('input[name="subscription"]');
    if (isSubscriptionProduct) {
      document.querySelectorAll('input[name="subscription"]:checked').forEach((el) => {
        let labelDiv = el.nextElementSibling;
        labelDiv.querySelector("label").click();
      });
    } else {
      const quantityInput = document.querySelector("jolly-quantity-selector input");
      const quantity = (quantityInput == null ? void 0 : quantityInput.value) || 1;
      const priceBlocks = document.querySelectorAll(".js-price-block");
      priceBlocks.forEach((addToCartBtn) => {
        const startingPrice = addToCartBtn.dataset.originalPrice;
        const originalPriceButton = addToCartBtn.querySelector(".jc-current-price");

        if (!document.querySelector("deployer-quantity-breaks")) {
          const currentCurrency = document.querySelector(".js-main-product")?.dataset?.currentCurrency || "€";
          originalPriceButton.innerHTML = `${currentCurrency}${((parseFloat(startingPrice.replace(/\D/g, "")) / 100) * quantity).toFixed(2).replace(".", ",")}`;
        }
      });
    }
  }

  /**
   * Fonction handlePricesAndDiscounts - version simplifiée pour les modals
   */
  handlePricesAndDiscounts() {
    // Version simplifiée - dans les modals on ne gère pas les prix complexes
    // Cette fonction est principalement pour les pages produit avec subscriptions
    console.log("handlePricesAndDiscounts called in modal context");
  }

  /**
   * Réattache les événements après mise à jour du HTML
   */
  reattachEventListeners() {
    // Supprimer les anciens événements
    this.elements.variants.forEach((element) => {
      element.removeEventListener("click", this.boundHandleVariantChange);
    });

    // Mettre à jour la liste des éléments
    this.elements.variants = this.querySelectorAll(".js-variants-update");

    // Réattacher les nouveaux événements
    this.elements.variants.forEach((element) => {
      element.addEventListener("click", this.boundHandleVariantChange);
    });
  }
}

// Enregistrer le custom element avec un nom différent
if (!customElements.get("variant-picker-reusable")) {
  customElements.define("variant-picker-reusable", VariantPicker);
}

// Utilitaires pour l'initialisation
window.VariantPickerUtils = {
  initAll() {
    document.querySelectorAll("variant-picker-reusable").forEach((picker) => {
      // Le picker s'initialise automatiquement via connectedCallback
    });
  },
};

// Auto-initialisation
document.addEventListener("DOMContentLoaded", () => {
  window.VariantPickerUtils.initAll();
});

document.addEventListener("variantChangeInitialized", () => {
  window.VariantPickerUtils.initAll();
});

function clickOnCheckedOption() {
  const isSubscriptionProduct = document.querySelector('input[name="subscription"]');
  if (isSubscriptionProduct) {
    document.querySelectorAll('input[name="subscription"]:checked').forEach((el) => {
      let labelDiv = el.nextElementSibling;
      labelDiv.querySelector("label").click();
    });
  } else {
    const quantityInput = document.querySelector("jolly-quantity-selector input");
    const quantity = (quantityInput == null ? void 0 : quantityInput.value) || 1;
    const priceBlocks = document.querySelectorAll(".js-price-block");
    priceBlocks.forEach((addToCartBtn) => {
      const startingPrice = addToCartBtn.dataset.originalPrice;
      const originalPriceButton = addToCartBtn.querySelector(".jc-current-price");

      if (!document.querySelector("deployer-quantity-breaks")) {
        originalPriceButton.innerHTML = `${currentCurrency}${((parseFloat(startingPrice.replace(/\D/g, "")) / 100) * quantity).toFixed(2).replace(".", ",")}`;
      }
    });
  }
}

function clickOnCheckedOption() {
  const isSubscriptionProduct = document.querySelector('input[name="subscription"]');
  if (isSubscriptionProduct) {
    document.querySelectorAll('input[name="subscription"]:checked').forEach((el) => {
      let labelDiv = el.nextElementSibling;
      labelDiv.querySelector("label").click();
    });
  } else {
    const quantityInput = document.querySelector("jolly-quantity-selector input");
    const quantity = (quantityInput == null ? void 0 : quantityInput.value) || 1;
    const priceBlocks = document.querySelectorAll(".js-price-block");
    priceBlocks.forEach((addToCartBtn) => {
      const startingPrice = addToCartBtn.dataset.originalPrice;
      const originalPriceButton = addToCartBtn.querySelector(".jc-current-price");

      if (!document.querySelector("deployer-quantity-breaks")) {
        originalPriceButton.innerHTML = `${currentCurrency}${((parseFloat(startingPrice.replace(/\D/g, "")) / 100) * quantity).toFixed(2).replace(".", ",")}`;
      }
    });
  }
}

async function getSectionHTML(sectionId, productId, isUpsale) {
  return new Promise(function (resolve, reject) {
    const query = "id:" + productId;
    const qq = productId ? "&q=" + query : "";
    const url = window.Shopify.routes.root + "search/?sections=" + sectionId + qq;
    fetch(url).then(function (r) {
      r.json().then(function (res) {
        var keys = Object.keys(res);
        if (keys.length > 0) {
          return resolve(res[keys[0]]);
        }
        return reject();
      });
    });
  });
}

async function renderIconBubble() {
  console.log("renderIconBubble");
  const section = document.getElementById("cart-icon-bubble").dataset.sectionId;
  const html = await getSectionHTML(section);
  const domparser = new DOMParser();
  const cartDom = domparser.parseFromString(html, "text/html");
  const iconBubble = document.querySelector("#cart-icon-bubble");
  iconBubble.innerHTML = cartDom.querySelector("#cart-icon-bubble").innerHTML;
}

document.addEventListener("rebuy:cart.change", (event) => {
  renderIconBubble();
});
